var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-to-basket"},[_vm._v(" +"+_vm._s(_vm.quantity)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }